import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";

import {
  GetSinglePembayaranVA,
  reset,
} from "../../../features/pembayaran_va/PembayaranVASlice";
import {
  reset as resetKodePay,
  GetAllKodePayDropdown,
  GetAllKodePayDropdownAdmin,
} from "../../../features/kodepayVASlice";
import {
  reset as resetSemester,
  GetConfigSemester,
} from "../../../features/config/ConfigSemesterSlice";
import {
  reset as resetFakultas,
  GetAllFakultasDropdown,
} from "./../../../features/FakultasSlice";
import { 
  reset as resetProdi,
  GetAllProdiDropdown,
} from './../../../features/ProdiSlice';
import { 
  reset as resetUserDiscount,
  GetUserDiscountByNimKode,
} from './../../../features/UserDiscountSlice';

import { Card, Button, Form, Col, Row } from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";
import {
  formatNumber,
  formatToRupiah,
  generateSemesterList,
  generateStudyYearsList,
  removeFormatter,
  removeTrailingZero,
} from "../../../helpers/helper";
import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import BASE_URL from "../../../api";
import { UserContext } from "../../../utils/ProtectedRoute";
import { faChevronCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const FormPembayaranVAPage = () => {
  const [dataPembayaranVA, setDataPembayaranVA] = useState({
    nim: "",
    va_name: "",
  });

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector(
    (state) => state.pembayaranVA
  );

  const {
    data: dataFakultasList,
    isLoading: isLoadingFakultasList,
    isError: isErrorFakultasList,
  } = useSelector((state) => state.fakultas);

  const {
    data: dataProdiList,
    isLoading: isLoadingProdiList,
    isError: isErrorProdiList,
  } = useSelector((state) => state.prodi);

  const {
    data: dataKodePayList,
    isLoading: isLoadingKodePayList,
    isError: isErrorKodePayList,
  } = useSelector((state) => state.kodepayVA);
  
  const {
    data: dataUserDiscount,
    isLoading: isLoadingUserDiscount,
    isError: isErrorUserDiscount,
  } = useSelector((state) => state.userDiscount);

  const { data: dataSemester, isLoading: isLoadingSemester } = useSelector(
    (state) => state.configSemester
  );

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  // on init (call once when the page has been loaded)
  useEffect(() => {
    // call api to fetch fakultas dropdown data
    dispatch(reset());
    dispatch(resetSemester());
    dispatch(GetConfigSemester(token));
    
    // only load when its neccessary.
    if (userData?.id_role !== "HA05") {
      dispatch(resetFakultas());
      dispatch(GetAllFakultasDropdown());
    } else {
      // only load when it is mahasiswa.
      // prevent unnecessary load user role staff
      dispatch(resetKodePay());
      dispatch(GetAllKodePayDropdown(token));
    }
    if (id) {
      // fetch all kode pay to auto select dropdown
      dispatch(resetKodePay());
      dispatch(GetAllKodePayDropdown(token));
      // then fetch the data
      dispatch(GetSinglePembayaranVA({ id, token }));
    }
  }, [id, dispatch, token, userData]);

  // init the model before send to Server, if any.
  // update the model if user role is meant for "MAHASISWA".
  useEffect(() => {
    const copyData = Object.assign(
      { ...data?.data },
      {
        va_name:
          userData?.id_role === "HA05"
            ? data?.data?.va_name || userData?.nama
            : data?.data?.va_name,
        va_nim:
          userData?.id_role === "HA05"
            ? data?.data?.va_nim || userData?.nim
            : data?.data?.va_nim,
        nominal: data?.data?.nominal,
        nominalMask: removeTrailingZero(data?.data?.nominal),
        payment_period: id
          ? data?.data?.payment_period
          : getDataSemester()
          ? getDataSemester().period
          : null,
        semester: id
          ? data?.data?.semester
          : getDataSemester()
          ? getDataSemester().type
          : null,
      }
    );
    setDataPembayaranVA({
      ...copyData,
    });
  }, [userData, data, dataSemester]);

  // REVISI DISCOUNT FOR SOME USER >
  // listen pembayaran VA
  const onChangeKodePay = (data) => {
    // get the kode fot the prefix.
    let prefix;
    if (userData?.id_role === "HA05") {
      prefix = userData?.kode_fakultas ?? "";
    } else {
      prefix = getFakultasList().find(
        (e) => e.value.id === dataPembayaranVA.id_fakultas
      ).value.kode;
    }
    // TODO :: CHECK IF IT IS PARTIAL, THEN CALLS AN API TO CALCULATE THE REMAINING PAYMENT
    dispatch(resetUserDiscount());
    dispatch(GetUserDiscountByNimKode({
      query: `nim=${dataPembayaranVA.va_nim}&kodePay=${data.kode}`,
      token,
    }));
    setDataPembayaranVA({
      ...dataPembayaranVA,
      id_kode_pay: data.id,
      va: `${prefix}${
        data.kode
      }${dataPembayaranVA.va_nim.substring(2)}`,
      kode_pembayaran: data.kode,
      payment_category: data.deskripsi,
      nominal: removeFormatter(data.nominal),
      nominalMask: formatNumber(data.nominal),
      cicilan: data.cicilan,
    });
  }
  
  useEffect(() => {
    if (dataUserDiscount?.data?.length > 0) {
      const originNominal = dataPembayaranVA.nominal;
      const discount = (originNominal)-(dataUserDiscount.data[0].discount_amt);
      setDataPembayaranVA({
        ...dataPembayaranVA,
        nominal: removeFormatter(discount),
        nominalMask: formatNumber(discount),
      });
    }
  }, [dataUserDiscount])
  // < END REVISI DISCOUNT FOR SOME USER 

  function getFakultasList() {
    try {
      const result = (dataFakultasList?.data || []).map((item, i) => ({
        value: item,
        label: `${item.kode} - ${item.nama}`,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }

  function getProdiList() {
    try {
      const result = (dataProdiList?.data || []).map((item, i) => ({
        value: item,
        label: `${item.kode} - ${item.nama}`,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }

  function getKodePayList() {
    try {
      const result = (dataKodePayList?.data || []).map((item, i) => ({
        value: item,
        label: `${item.kode} - ${item.deskripsi}`,
      }));
      return result;
    } catch (error) {
      return [];
    }
  }

  function getDataSemester() {
    try {
      const result = dataSemester?.data[0];
      return result;
    } catch (error) {
      return null;
    }
  }
  
  // listen some changes here
  useEffect(() => {
    if (dataPembayaranVA.id_fakultas) {
      dispatch(resetProdi());
      dispatch(GetAllProdiDropdown({id: dataPembayaranVA.id_fakultas}));
    }
  }, [dataPembayaranVA.id_fakultas]);
  // TODO :: DISABLE FORM PRODI IF THE NIM FIELD IS EMPTY
  useEffect(() => {
    if (dataPembayaranVA.id_prodi && dataPembayaranVA.va_nim.length > 4) {
      dispatch(resetKodePay());
      dispatch(GetAllKodePayDropdownAdmin({query: `?tahunAngkatan=${dataPembayaranVA.va_nim.substring(0, 4)}&idProdi=${dataPembayaranVA.id_prodi}`, token}));
    }
  }, [dataPembayaranVA.id_prodi]);

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.put(
              `${BASE_URL}va/${id}`,
              {
                ...dataPembayaranVA,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}va`,
              {
                ...dataPembayaranVA,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate("/va/list");
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  const onExtendsTap = () => {
    showAlertDialog({
      title: "Perpanjang?",
      msg: "Apakah anda yakin ingin memperpanjang masa berlaku VA ini?",
      confirmButtonText: "Perpanjang",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.put(`${BASE_URL}va/extends/${id}`, null, {
              headers: {
                Authorization: token,
              },
            });
            console.log("RESPONSE : ", response);
            hideLoadingDialog();
            showSuccessDialog({
              title: "Berhasil!",
              msg: "Berhasil memperpanjang masa berlaku VA!",
            });
            dispatch(GetSinglePembayaranVA({ id, token }));
          } else {
            throw "id not found!";
          }
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg:
              error?.response?.data?.message ||
              "Gagal memperpanjang masa berlaku VA!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[2] === "detail" ? (
        <>
          <Header title="Detail Pembayaran VA">
            {dataPembayaranVA?.paid ? null : (
              <Button 
                size="sm" 
                variant="success" 
                onClick={onExtendsTap} 
                className="me-2">
                  Perpanjang
              </Button>
            )}
            <Button
              variant="outline-primary"
              size="sm"
              as={Link}
              to={`/va/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[2] === "create" ? (
        <>
          <Header title="Buat Pembayaran VA">
            <Button
              variant="outline-primary"
              size="sm"
              as={Link}
              to={`/va/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[2] === "edit" ? (
        <>
          <Header title="Edit Pembayaran VA">
            <Button
              variant="outline-primary"
              size="sm"
              as={Link}
              to={`/va/list`}
            >
              <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          dataPembayaranVA={dataPembayaranVA}
          setDataPembayaranVA={setDataPembayaranVA}
          handleSubmit={handleSubmit}
          formDisable={param.pathname.split("/")[2] === "detail" ? true : false}
          formDisableNotAdmin={userData?.id_role === "HA05"}
          isLoading={isLoading}
          isError={isError}
          // fakultas
          isLoadingFakultasList={isLoadingFakultasList}
          isErrorFakultasList={isErrorFakultasList}
          dataFakultasList={getFakultasList()}
          // prodi
          isLoadingProdiList={isLoadingProdiList}
          isErrorProdiList={isErrorProdiList}
          dataProdiList={getProdiList()}
          // kodePay
          isLoadingKodePayList={isLoadingKodePayList}
          isErrorKodePayList={isErrorKodePayList}
          dataKodePayList={getKodePayList()}
          onChangeKodePay={onChangeKodePay}
          // semester
          isLoadingSemester={isLoadingSemester}
          dataSemester={getDataSemester()}
          // REVISI
          // HANDLE SOME STATE CHANGES HERE
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = (props) => {
  const {
    isLoading,
    isError,
    dataPembayaranVA,
    setDataPembayaranVA,
    id,
    handleSubmit,
    formDisable,
    formDisableNotAdmin,
    // fakultas
    isLoadingFakultasList,
    isErrorFakultasList,
    dataFakultasList,
    // prodi
    isLoadingProdiList,
    isErrorProdiList,
    dataProdiList,
    // id_kode_pay
    isLoadingKodePayList,
    isErrorKodePayList,
    dataKodePayList,
    // data semester
    isLoadingSemester,
    dataSemester,
    // callback
    onChangeKodePay,
  } = props;

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            {isError ? "something error" : null}
            <Col md={12} className="mb-3">
              <Form.Group id="nim">
                <Form.Label>NIM</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="NIM"
                  name="nim"
                  disabled={formDisable || formDisableNotAdmin || dataPembayaranVA?.id_fakultas || dataPembayaranVA?.id_kode_pay}
                  value={dataPembayaranVA.va_nim || ""}
                  onChange={(e) =>
                    setDataPembayaranVA({
                      ...dataPembayaranVA,
                      va_nim: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="va_name">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nama"
                  name="nama"
                  disabled={formDisable || formDisableNotAdmin || dataPembayaranVA?.id_fakultas || dataPembayaranVA?.id_kode_pay}
                  value={dataPembayaranVA.va_name || ""}
                  onChange={(e) =>
                    setDataPembayaranVA({
                      ...dataPembayaranVA,
                      va_name: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>

            {!formDisable && !formDisableNotAdmin && userData?.id_role !== "HA05" ? (
              <>
                <Col md={12} className="mb-3">
                  <Form.Group id="id_fakultas">
                    <Form.Label>Fakultas</Form.Label>
                    <Select
                      options={dataFakultasList}
                      placeholder="Pilih fakultas"
                      required
                      isLoading={isLoadingFakultasList}
                      isDisabled={dataPembayaranVA?.id_kode_pay || dataPembayaranVA?.va_nim == null || dataPembayaranVA?.va_name == null}
                      onChange={(e) => {
                        if ((dataPembayaranVA?.va || "").length > 10) {
                          const oldVASbstr =
                            dataPembayaranVA?.va.substring(5);
                          setDataPembayaranVA({
                            ...dataPembayaranVA,
                            va: `${e.value.kode}${oldVASbstr}`,
                            id_fakultas: `${e.value.id}`,
                          });
                        } else {
                          setDataPembayaranVA({
                            ...dataPembayaranVA,
                            id_fakultas: `${e.value.id}`,
                          });
                        }
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Group id="id_prodi">
                    <Form.Label>Prodi</Form.Label>
                    <Select
                      options={dataProdiList}
                      placeholder="Pilih prodi"
                      required
                      isLoading={isLoadingProdiList}
                      isDisabled={formDisable || !dataPembayaranVA?.id_fakultas || dataPembayaranVA?.id_kode_pay}
                      onChange={(e) => {
                        setDataPembayaranVA({
                          ...dataPembayaranVA,
                          id_prodi: e.value.id,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
              </>
            ) : null}

            <Col md={12} className="mb-3">
              <Form.Group id="id_kode_pay">
                <Form.Label>Kategori Pembayaran</Form.Label>
                <Select
                  options={dataKodePayList}
                  placeholder="Pilih kode pembayaran"
                  value={dataKodePayList?.find(
                    (e) => e.value.id === dataPembayaranVA.id_kode_pay
                  )}
                  required
                  isLoading={isLoadingKodePayList}
                  isDisabled={
                    formDisable || (dataPembayaranVA.va_nim || "").length < 10
                  }
                  onChange={(e) => onChangeKodePay(e.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="va">
                <Form.Label>VA</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="-"
                  name="va"
                  disabled={true}
                  value={dataPembayaranVA.va || ""}
                  // onChange={(e) =>
                  //   setDataPembayaranVA({
                  //     ...dataPembayaranVA,
                  //     va: e.target.value,
                  //   })
                  // }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="nominal">
                <Form.Label>Nominal</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="0"
                  name="nominal"
                  disabled={formDisable || !dataPembayaranVA.cicilan}
                  value={dataPembayaranVA.nominalMask || ""}
                  onChange={(e) =>
                    setDataPembayaranVA({
                      ...dataPembayaranVA,
                      nominal: removeFormatter(e.target.value),
                      nominalMask: formatNumber(e.target.value),
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="cicilan">
                <Form.Label>Bisa Dicicil?</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="-"
                  name="cicilan"
                  disabled={true}
                  value={dataPembayaranVA.cicilan ? "Bisa" : "Tidak Bisa"}
                  // onChange={(e) =>
                  //   setDataPembayaranVA({
                  //     ...dataPembayaranVA,
                  //     cicilan: e.target.value,
                  //   })
                  // }
                />
              </Form.Group>
            </Col>
            {isLoadingSemester ? null : (
              <>
                <Col md={12} className="mb-3">
                  <Form.Group id="payment_period">
                    <Form.Label>Periode Pembayaran</Form.Label>
                    <Select
                      options={generateStudyYearsList()}
                      placeholder="Pilih periode pembayaran"
                      value={generateStudyYearsList()?.find(
                        (e) => e.value === dataPembayaranVA.payment_period
                      )}
                      required
                      isDisabled={formDisable || dataSemester}
                      onChange={(e) => {
                        setDataPembayaranVA({
                          ...dataPembayaranVA,
                          payment_period: e.value,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Group id="semester">
                    <Form.Label>Semester</Form.Label>
                    <Select
                      options={generateSemesterList()}
                      placeholder="Pilih semester"
                      value={generateSemesterList()?.find(
                        (e) => e.value === dataPembayaranVA.semester
                      )}
                      required
                      isDisabled={formDisable || dataSemester}
                      onChange={(e) => {
                        setDataPembayaranVA({
                          ...dataPembayaranVA,
                          semester: e.value,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
              </>
            )}
            <Col md={12} className="mb-3">
              <Form.Group id="keterangan">
                <Form.Label>Keterangan</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="-"
                  name="keterangan"
                  disabled={formDisable}
                  value={dataPembayaranVA.keterangan || ""}
                  onChange={(e) =>
                    setDataPembayaranVA({
                      ...dataPembayaranVA,
                      keterangan: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            {formDisable ? (
              <Col md={12} className="mb-3">
                <Form.Group id="paid">
                  <Form.Label>Lunas?</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="paid"
                    disabled={true}
                    value={dataPembayaranVA.paid ? "LUNAS" : "BELUM LUNAS"}
                    // onChange={(e) =>
                    //   setDataPembayaranVA({
                    //     ...dataPembayaranVA,
                    //     paid: e.target.value,
                    //   })
                    // }
                  />
                </Form.Group>
              </Col>
            ) : null}
            {formDisable && dataPembayaranVA.expired_date ? (
              <Col md={12} className="mb-3">
                <Form.Group id="expired_date">
                  <Form.Label>Tanggal Expired</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="expired_date"
                    disabled={true}
                    value={moment(dataPembayaranVA.expired_date).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                    // onChange={(e) =>
                    //   setDataPembayaranVA({
                    //     ...dataPembayaranVA,
                    //     expired_date: e.target.value,
                    //   })
                    // }
                  />
                </Form.Group>
              </Col>
            ) : null}
            {formDisable && dataPembayaranVA.created_at ? (
              <Col md={12} className="mb-3">
                <Form.Group id="created_at">
                  <Form.Label>Tanggal Dibuat</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="-"
                    name="created_at"
                    disabled={true}
                    value={moment(dataPembayaranVA.created_at).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                    // onChange={(e) =>
                    //   setDataPembayaranVA({
                    //     ...dataPembayaranVA,
                    //     created_at: e.target.value,
                    //   })
                    // }
                  />
                </Form.Group>
              </Col>
            ) : null}
          </Row>
          {formDisable ? null : (
            <div>
              {id ? (
                <Button type="submit" disabled={isLoading}>
                  Update
                </Button>
              ) : (
                <Button type="submit" disabled={isLoading}>
                  Simpan
                </Button>
              )}
            </div>
          )}
        </Form>
      )}
    </Card.Body>
  );
};

export default FormPembayaranVAPage;
